<component :is="club.route && !showAction ? 'router-link' : 'article'" :to="club.route && !showAction ? club.route : undefined"
  class="homepage-club-card"
  :style="{ backgroundImage: `linear-gradient(180deg, rgba(0,0,0,.25), rgba(0,0,0,.94)), ${imageBackground(club.background, 300, 228)}` }">
  <header v-if="$slots.header"><slot name="header" /></header>
  <div class="homepage-club-card__main">
    <img :src="club.logo" :srcset="club.logoSrcset" sizes="100px" :alt="club.name" />
    <h3>{{ club.name }}</h3>
    <p>{{ club.city }}</p>
    <p v-if="place?.name"><i class="bi bi-geo-alt me-1" aria-hidden="true"></i>{{ place.name }}</p>
    <p v-if="place?.address">{{ place.address }}</p>
  </div>
  <div v-if="showStats">
    <span>{{ $t('clubs.tournamentsCount', club.tournaments) }}</span>
    <span>{{ $t('clubs.playersCount', club.players) }}</span>
  </div>
  <router-link v-if="showAction && club.route" :to="club.route" class="public-club-card__action">{{ $t('clubs.openClub') }}<i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
  <footer v-if="$slots.footer"><slot name="footer" /></footer>
</component>
